/* eslint-disable jsx-a11y/anchor-is-valid */
import {Link} from 'react-router-dom'
import {useUser} from '../../modules/newauth/UserContext'

export function MyProfileWrapper() {
  const {user} = useUser()

  return (
    <>
      <div className='d-flex flex-wrap flex-stack mb-6'>
        <h3 className='fw-bolder my-2'>My Profile</h3>

        <div className='d-flex my-2'>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={'/my-profile'} className='pe-3'>
                My Profile
              </Link>
            </li>
          </ol>
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Profile Details</h3>
          </div>

          {/* <Link to='/crafted/account/settings' className='btn btn-primary align-self-center'>
            Edit Profile
          </Link> */}
        </div>

        <div className='card-body p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>Avatar</label>
            <div className='col-lg-8'>
              <div className='symbol symbol-100px'>
                <img src={user?.imageProfile} alt='' />
              </div>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Full Name</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {user?.firstName} {user?.lastName}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Email</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{user?.email}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Role</label>

            <div className='col-lg-8'>
              <span className='fw-bold fs-6'>{user?.role}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User ID</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{user?.userId}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User ID in Malin1</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{user?.userIdMalin1}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
